import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

import Expandable from '../../../expandable/expandable';
import DrawerToggle from './drawer-toggle';

import styles from './expanding-table.module.less';

const Tbody = ({ columns, row, index }) => (
  <Expandable
    render={(toggleExpanded, isExpanded) => (
      <tbody
        key={row.key}
        className={classNames([
          styles.tbody,
          {
            [styles.stripedBackground]: index % 2 !== 0,
          },
        ])}
      >
        <tr key={`${row.key} Summary`} className={styles.tr}>
          {columns.map((column, i) => {
            const style = column.mobileOrder
              ? { order: column.mobileOrder }
              : {};

            return (
              <td
                key={column.id}
                style={style}
                className={classNames([
                  column.id,
                  styles.td,
                  { [styles.hideOnMobile]: column.hideOnMobile },
                  row.className,
                ])}
              >
                {
                  /* on mobile, add column headers to the middle row only */
                  i !== 0 && i !== columns.length - 1 && (
                    <div className={styles.mobileColumnHeading}>
                      {column.heading}
                    </div>
                  )
                }
                <div className={styles.tdContents}>{_.get(row, column.id)}</div>
                {i === 0 && (
                  <DrawerToggle
                    className={styles.hideOnMobile}
                    isExpanded={isExpanded}
                    toggleExpanded={toggleExpanded}
                  />
                )}
              </td>
            );
          })}
        </tr>
        {isExpanded && (
          <tr
            key={`${row.key} Details`}
            className={styles.detailsSection}
            data-integration="details-section"
          >
            <td colSpan={columns.length}>Details Placeholder</td>
          </tr>
        )}
        <tr className={styles.mobileDrawerToggle}>
          <DrawerToggle
            isExpanded={isExpanded}
            toggleExpanded={toggleExpanded}
          />
        </tr>
      </tbody>
    )}
  />
);

Tbody.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  index: PropTypes.number.isRequired,
  row: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Tbody;
